import React from 'react'
import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

import UnauthenticatedNavigation from '../UnauthenticatedNavigation'
import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'

export default function StaticPageMenu() {
  const navigate = useNavigate()

  const handleNavClick = (e) => {
    let path = e.currentTarget.href.replace(/https?\:\/\//, '')
      .replace(e.currentTarget.host, '')
    navigate(path)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
        }}
      >
        <IconButton
          onClick={handleNavClick}
          href='/app/welcome'
          edge='start'
          aria-label='home page'
          sx={{
            paddingRight: '2px',
            color: 'white',
          }}
          size='large'
        >
          <img src={StikisLogoTiny} id='stikisLogoTiny' alt='Stikis logo' />
          <Typography
            variant='h1'
            sx={{
              fontWeight: 900,
              fontSize: '2rem',
            }}
          >
            stikis
          </Typography>
        </IconButton>
      </Box>
      <UnauthenticatedNavigation />
    </React.Fragment>
  )
}
